<meta name="viewport" content="width=device-width, initial-scale=1.0"></meta>
<template>
  <div class="block galleryBlock backLight">
    <v-container class="backLight">
      <h2 class="text-center backLight">Discover Thing Descriptions</h2>
          <v-img
            src="../../assets/wot.png"
            class="mx-auto backLight"
            max-width="300"
            max-height="300"
          ></v-img>
         <p style="font-size: 20px">
            <center>
            Take a look at the Thing Descriptions section to search fully
            working Thing Descriptions.
          </center>
        </p>
      <center>
            <v-btn depressed color="primary" href="https://www.w3.org/WoT/">
              Learn more about WoT
            </v-btn>
          </center>
    </v-container>
  </div>
  
</template>

<script>
export default {
  name: "DeviceStatus",
};
</script>

<style>
    .backLight {
        background: #dddfe3;
    }	
</style>